import React from "react";
import { Link } from "react-router-dom";

const Showcase = () => {
  return (
    <header id="showcase">
      <div className="container">
        <div className="showcase-container">
          <div className="showcase-content">
            <h1>Welcome to Pedres Flooring</h1>
            <p>
              Welcome to Wellington's premier flooring service! We are dedicated
              to transforming your space with top-notch flooring solutions that
              offer both affordability and quality. With our wide selection of
              high-quality materials and expert installations, we ensure that
              you receive the best value for your investment.
            </p>
            <p>
              From hardwood and laminate to carpet and tile, we offer a diverse
              range of flooring options to suit your style and budget. Our team
              of experts is committed to delivering flawless installations,
              ensuring that your new flooring is installed with precision and
              care. We take pride in our attention to detail and exceptional
              craftsmanship, ensuring that your space is transformed into a
              beautiful and long-lasting result.
            </p>
            <p>
              Experience the combination of affordability and quality that sets
              us apart. Trust us to provide exceptional customer service, listen
              to your needs, and guide you towards the perfect flooring solution
              for your home. Discover the flooring excellence within reach and
              elevate your living spaces with our comprehensive flooring
              service.
            </p>
            <p>Here, we make flooring excellence within reach.</p>
            <Link to="/quote" className="link-btn">
              Get a Quote
            </Link>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Showcase;
